module.exports = __webpack_public_path__ + "static/edward-6bb634eced3a298639858cb159628456.jpg";